module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp3-01-845c8a93df7973d794caad8b03cc6a97.png";